import {
  Sale_CloseOutStatus as SaleCloseOutStatus,
  Sale_Source as SaleSource,
  Sale_Status as SaleStatus,
} from "gen/txn/models_pb"

export function isSaleFinalized(status?: SaleStatus): boolean {
  return (
    status === SaleStatus.PAID ||
    status === SaleStatus.SOLD ||
    status === SaleStatus.VOIDED
  )
}

// Mirrors Sale_Status.IsDepositable on the backend.
export function isSaleDepositable(
  status: SaleStatus | undefined,
  source: SaleSource | undefined,
  isGeneralizeDepositsCloseOutsEnabled: boolean
): boolean {
  if (status === SaleStatus.SPECIAL_ORDER) {
    return true
  }
  // TODO: include ecomm sales once SpecialOrderSaleForm supports them — it has
  // no online-order back navigation or ecomm-specific actions yet (UU-6323).
  if (source === SaleSource.ECOMM) {
    return false
  }
  return (
    isGeneralizeDepositsCloseOutsEnabled &&
    (status === SaleStatus.QUOTED || status === SaleStatus.WILL_CALLED)
  )
}

export function getCloseOutStatusDisplay({
  status,
  closeOutStatus,
  source,
  isGeneralizeDepositsCloseOutsEnabled,
}: {
  status?: SaleStatus
  closeOutStatus?: SaleCloseOutStatus
  source?: SaleSource
  isGeneralizeDepositsCloseOutsEnabled: boolean
}): {
  showCloseOutStatus: boolean
  closeOutText: string
  closeOutColor: "gray" | "green"
} {
  const isCloseOutableStatus =
    status === SaleStatus.SPECIAL_ORDER ||
    (isGeneralizeDepositsCloseOutsEnabled &&
      (status === SaleStatus.QUOTED || status === SaleStatus.WILL_CALLED))
  const isFullyClosedOut = closeOutStatus === SaleCloseOutStatus.FULL
  return {
    showCloseOutStatus:
      source !== SaleSource.ECOMM &&
      isCloseOutableStatus &&
      (closeOutStatus === SaleCloseOutStatus.PENDING || isFullyClosedOut),
    closeOutText: isFullyClosedOut ? "Closed" : "Open",
    closeOutColor: isFullyClosedOut ? "gray" : "green",
  }
}

export const SaleStatusFormatted = new Map<SaleStatus, string>([
  [SaleStatus.CREATED, "Created"],
  [SaleStatus.QUOTED, "Quoted"],
  [SaleStatus.WILL_CALLED, "Will called"],
  [SaleStatus.SOLD, "Sold"],
  [SaleStatus.PAID, "Sold"],
  [SaleStatus.VOIDED, "Voided"],
  [SaleStatus.SPECIAL_ORDER, "Special order"],
])
